import type { MouseEventHandler, ReactNode } from 'react';
import type { ModalData } from '..';

export interface ApplicationConfirmationModalData {
  modal: ModalData;
  onConfirm?: MouseEventHandler;
  illustration?: ReactNode;
  loading?: boolean;
  daysLeft?: number | null;
}

export interface ApplicationConfirmationModalProps extends ApplicationConfirmationModalData {}
